import dashboardIndex from "../views/dashboard/dashboard-index-v2.vue";
import dashboardIndex2 from "../views/dashboard/dashboard-index-v2-test.vue";

export default [
  {
    path: "/app/:userDeptRoleId/dashboard",
    name: "dashboard",
    components: {
      default: dashboardIndex2
    }
  },
  {
    path: "/app/:userDeptRoleId/dashboard2",
    name: "dashboard2",
    components: {
      default: dashboardIndex
    }
  },
  {
    path: "/app/:userDeptRoleId/vanBanDenDetail/:id",
    name: "vanBanDenDetail",
    components: {
      default: () => import("../views/dashboard/index.vue"),
      detail: () => import("../views/doc-in/Detail.vue")
    }
  },
  {
    path: "/app/:userDeptRoleId/vanBanDiDetail/:id",
    name: "vanBanDiDetail",
    components: {
      default: () => import("../views/dashboard/index.vue"),
      detail: () => import("../views/doc-out/Detail.vue")
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js